module.exports = __webpack_public_path__ + "static/oea-19ba13387bd857b2f4332be73530c41b.png";